module.exports = __webpack_public_path__ + "images/avatars/female/13.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/13.svg
// module id = Dc98
// module chunks = 154